import { render, staticRenderFns } from "./ModalRemoveSupervisor.vue?vue&type=template&id=734c9b81&scoped=true&"
import script from "./ModalRemoveSupervisor.vue?vue&type=script&lang=js&"
export * from "./ModalRemoveSupervisor.vue?vue&type=script&lang=js&"
import style0 from "./ModalRemoveSupervisor.vue?vue&type=style&index=0&id=734c9b81&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "734c9b81",
  null
  
)

export default component.exports